import { useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import CustomTitle from '../../components/CustomMiscellaneous/CustomTitle';
import useMemoryState from '../../hooks/memoryStateHook';
import FaturacaoClientes from './FaturacaoClientes/FaturacaoClientes';
import FaturacaoFornecedores from './FaturacaoFornecedores/FaturacaoFornecedores';



export default function Faturacao() {

  const [tab, setTab] = useMemoryState('f-tab', 0)


    return (
      <div>           
        <div style={{margin: 20}} >

      {/*  TODO add this back to TAbs variant='soft-rounded' */}

        <Tabs  selectedIndex={tab} onSelect={(index)=> setTab(index)}>
            <TabList>
              <Tab>Clientes</Tab>
              <Tab>Fornecedores</Tab>


            </TabList>
            
            <TabPanel>
         <FaturacaoClientes/>
       </TabPanel>
       <TabPanel>
         <FaturacaoFornecedores/>
       </TabPanel>
        </Tabs>
        </div>
        </div>
    )


}